import React from 'react'
import PropTypes from 'prop-types'
import Link from 'redux-first-router-link'
import { connect } from 'react-redux'
import getPreviousPage from '../../../redux/selectors/getPreviousPage'

const BackLink = ({ children, previousPage }) => {
    const previousPageAction = {
        type: previousPage,
        meta: {
            gameState: 'routing',
        },
    }
    return (
        <Link className="backLink--wrapper" to={previousPageAction}>
            {React.Children.map(children, child => child)}
        </Link>
    )
}

BackLink.propTypes = {
    children: PropTypes.node.isRequired,
    previousPage: PropTypes.string.isRequired,
}

const mapStateToProps = state => ({
    previousPage: getPreviousPage(state),
})

export default connect(
    mapStateToProps,
)(BackLink)
